const YT = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
const TW = /^https?:\/\/(?:www\.|mobile\.)?(?:twitter|x)\.com\/([A-Za-z0-9_]+)\/status(?:es)?\/(\d+)/;
const IG = /^https?:\/\/(?:www\.)?instagram\.com\/(?:[A-Za-z0-9_.]+\/)?(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/;

export const PROVIDER_LABEL = { youtube: "YouTube", twitter: "X (Twitter)", instagram: "Instagram" };

export function detectEmbed(raw) {
  const url = (raw || "").trim();
  if (!/^https?:\/\//i.test(url)) return null;
  let m = url.match(YT);
  if (m) return { provider: "youtube", id: m[1], url: `https://www.youtube.com/watch?v=${m[1]}` };
  m = url.match(TW);
  if (m) return { provider: "twitter", id: m[2], url: `https://twitter.com/${m[1]}/status/${m[2]}` };
  m = url.match(IG);
  if (m) {
    const kind = m[1] === "reels" ? "reel" : m[1];
    return { provider: "instagram", id: m[2], url: `https://www.instagram.com/${kind}/${m[2]}/` };
  }
  return null;
}

const esc = (s) => String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");

export function embedHtml(provider, url) {
  const info = detectEmbed(url);
  if (!info || info.provider !== provider) return `<p><a href="${esc(url)}" target="_blank" rel="noopener noreferrer">${esc(url)}</a></p>`;
  if (provider === "youtube") {
    return `<div class="pwm-embed-live pwm-embed-youtube"><div class="video-wrapper"><iframe src="https://www.youtube-nocookie.com/embed/${info.id}" title="YouTube video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy"></iframe></div></div>`;
  }
  if (provider === "twitter") {
    return `<div class="pwm-embed-live pwm-embed-twitter"><blockquote class="twitter-tweet" data-dnt="true"><a href="${esc(info.url)}">View post on X</a></blockquote></div>`;
  }
  return `<div class="pwm-embed-live pwm-embed-instagram"><blockquote class="instagram-media" data-instgrm-permalink="${esc(info.url)}" data-instgrm-version="14"><a href="${esc(info.url)}">View post on Instagram</a></blockquote></div>`;
}

const loaded = {};
export function loadScriptOnce(src) {
  if (loaded[src]) return loaded[src];
  loaded[src] = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = resolve;
    s.onerror = resolve;
    document.body.appendChild(s);
  });
  return loaded[src];
}
